import { Component, Input } from '@angular/core';
import {Candidature} from "../../../../../models/Candidature";
import {textSubstring} from "../../../../../shared/utils/utils.functions";

@Component({
  selector: 'app-candidature-mission',
  templateUrl: './candidature-mission.component.html',
  styleUrl: './candidature-mission.component.scss'
})
export class CandidatureMissionComponent {
  @Input() data: any;
  @Input() column: any; // Define input property for 'column'

  candidature: any
  constructor(){


  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.candidature = this.data;
  }

  protected readonly textSubstring = textSubstring;
}
